import script from "./ForwardMessageSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForwardMessageSelect.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__